<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/18N1C2N/tc-custom/9780226410791.jpg?1722579349851" alt="This image is the cover for the book On Revision"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">On Revision
      </h1>
      <p class="bookDescription body article font2">
        <b>A trusted editor turns his attention to the most important part of writing: revision.</b><br/><br/> So you’ve just finished writing something? Congratulations! Now revise it. Because revision is about getting from good to better, and it’s only finished when you decide to stop. But where to begin? In <i>On Revision</i>, William Germano shows authors how to take on the most critical stage of writing anything: rewriting it.<br/><br/> For more than twenty years, thousands of writers have turned to Germano for his insider’s take on navigating the world of publishing. A professor, author, and veteran of the book industry, Germano knows what editors want and what writers need to know: Revising is not just correcting typos. Revising is about listening and seeing again. Revising is a rethinking of the principles from the ground up to understand why the writer is doing something, why they’re going somewhere, and why they’re taking the reader along with them.<br/><br/><i>On Revision</i> steps back to take in the big picture, showing authors how to hear their own writing voice and how to reread their work as if they didn’t write it. <i>On Revision</i> will show you how to know when your writing is actually done—and, until it is, what you need to do to get it there.<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        William Germano
      </h2>
      
      <p class="authorDescription body article"><P><B>William Germano</B> is the author of several books, including <I>Getting It Published: A Guide for Scholars and Anyone Else Serious about Serious Books</I> and <I>From Dissertation to Book</I>, both also published by the University of Chicago Press. His most recent book, co-written with Kit Nicholls, is <I>Syllabus: The Remarkable, Unremarkable Document That Changes Everything</I>. He has served as editor-in-chief at Columbia University Press, vice president and publishing director at Routledge, and dean of the faculty of humanities and social sciences at the Cooper Union for the Advancement of Science and Art, where he is now professor of English literature.&#160;</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?69c1f36b